import React from 'react';
import { BrPrimitive } from './BrPrimitive'

export const Br = props => {
    return <BrPrimitive />
}
